import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';

@Injectable({
  providedIn: 'root'
})
export class ApiLogsService {

  constructor(
    private baseClient: BaseclientService
  ) { }

  getClientAccountLogs(): Promise<any> {
    return this.baseClient.getBase("getClientAccountLogs");
  }

}
